import script from "./HomeScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeScreen.vue?vue&type=script&setup=true&lang=js"

import "./HomeScreen.vue?vue&type=style&index=0&id=a980087e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a980087e"]])

export default __exports__